/* global axios */
import ApiClient from '../../ApiClient';

class WhatsappCallsAPI extends ApiClient {
  constructor() {
    super('whatsapp_calls', { accountScoped: true });
  }

  show(callId) {
    return axios.get(`${this.url}/${callId}`).then(r => r.data);
  }

  initiate(conversationId, sdpOffer) {
    const payload = { conversation_id: conversationId };
    if (sdpOffer) payload.sdp_offer = sdpOffer;
    return axios.post(`${this.url}/initiate`, payload).then(r => r.data);
  }

  accept(callId, sdpAnswer) {
    const payload = {};
    if (sdpAnswer) payload.sdp_answer = sdpAnswer;
    return axios
      .post(`${this.url}/${callId}/accept`, payload)
      .then(r => r.data);
  }

  reject(callId) {
    return axios.post(`${this.url}/${callId}/reject`).then(r => r.data);
  }

  terminate(callId) {
    return axios.post(`${this.url}/${callId}/terminate`).then(r => r.data);
  }

  startWebrtc(callId, sdpOffer) {
    return axios
      .post(`${this.url}/${callId}/webrtc`, { sdp_offer: sdpOffer })
      .then(r => r.data);
  }

  uploadRecording(callId, blob, filename = 'call-recording.webm') {
    const formData = new FormData();
    formData.append('recording', blob, filename);
    return axios
      .post(`${this.url}/${callId}/upload_recording`, formData)
      .then(r => r.data);
  }
}

export default new WhatsappCallsAPI();
